import {uploadApi} from "./api"

//用户自动上传
export const UPLOAD_IMAGE = file => {
    let data = new FormData()
    data.append("file", file)
    return uploadApi("/upload/image")(data)
}
// 用户点击上传
export const UPDATE_AVATAR = file => {
    let data = new FormData()
    data.append("file", file)
    return uploadApi("/user/set/avatar")(data)
}
// 企业图片自动上传
export const UPLOAD_IMFIRM = (file,firmId) => {
    let data = new FormData()
    data.append("files", file)
    data.append("firmId",firmId)
    return uploadApi("/firm/imgs/add",true)(data)
}
// 企业图片自动上传
export const UPLOAD_CHANGEIMG = (file,firmId) => {
    let data = new FormData()
    data.append("file", file)
    data.append("projectId",firmId)
    return uploadApi("/project/img/update",true)(data)
}
//企业logo上传
export const UPLOAD_FILMLOGO = (file,firmId) => {
    let data = new FormData()
    data.append("file",file)
    data.append("firmId",firmId)
    return uploadApi("/firm/change/logo",true)(data)
}

// 更新用户头像

export const UPDATE_USERUPDATA = (file,uid) => {
    let data = new FormData()
    data.append("file", file)
    data.append("uid", uid)
    return uploadApi("/user/set/otheravatar",true)(data)
}
//删除企业图
// export const UPDATE_USERDELETE = (file,id) => {
//     let data = new FormData()
//     data.append("file", file)
//     data.append("id", id)
//     return uploadApi("/firm/imgs/del",true)(data)
// }